import { useEffect, useMemo } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import UniversalRecordTable from '../../components/Tables/universalRecord/UniversalRecordTable';
import { useQzTrayCertificate } from '../../hooks/qztray/useQzTrayCertificate';
import QzTrayCertificateUploadModal from '../../components/qztray/certificate/QzTrayCertificateUploadModal';
import QzTrayCertificateEditModal from '../../components/qztray/certificate/QzTrayCertificateEditModal';
import { QzTrayCertificate } from '../../types/qztray/QzTrayCertificateTypes';
import { qzTrayCertificateColumns } from '../../constants/qztray/qzTrayCertificateColumns';

/**
 * 🖨️ Página: Certificados Digitales QZ Tray
 */
const QzTrayCertificates = () => {
  const {
    certificates,
    isLoading,
    isSubmitting,
    certificateToEdit,
    fetchCertificates,
    uploadCertificate,
    updateCertificate,
    deleteCertificate,
    editModalOpen,
    uploadModalOpen,
    openUploadModal,
    closeUploadModal,
    closeEditModal,
    selectCertificateToEdit,
  } = useQzTrayCertificate();

  const columns = useMemo(() => qzTrayCertificateColumns, []);

  useEffect(() => {
    fetchCertificates();
  }, []);

  const getActions = (row: QzTrayCertificate) => [
    {
      key: 'edit',
      label: 'Actualizar',
      onClick: () => selectCertificateToEdit(row),
    },
    {
      key: 'cancel',
      label: 'Eliminar',
      onClick: async () => {
        await deleteCertificate(row.type);
      },
    },
  ];


  console.log('certificates', certificates);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <UniversalRecordTable
        columns={columns}
        data={certificates}
        getActions={getActions}
        showPagination={false}
        enableRowClick={true}
        noDataMessage="No hay certificados QZ Tray cargados."
        isLoading={isLoading}
        topRightAction={{
          label: 'Subir Certificado',
          onClick: openUploadModal,
        }}
      />

      {/* 📤 Modal: Subir nuevo certificado */}
      <QzTrayCertificateUploadModal
        isOpen={uploadModalOpen}
        onClose={closeUploadModal}
        onSubmit={uploadCertificate}
        isSubmitting={isSubmitting}
      />

      {/* ✏️ Modal: Editar certificado existente */}
      <QzTrayCertificateEditModal
        isOpen={editModalOpen}
        onClose={closeEditModal}
        onSubmit={updateCertificate}
        initialType={certificateToEdit?.type || null}
        isSubmitting={isSubmitting}
      />
    </DefaultLayout>
  );
};

export default QzTrayCertificates;
